module.exports = __webpack_public_path__ + "e700d833be637cc3507b809c92ddbe31.svg";